import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

// noneOption: pode ser um objeto { value, label } OU um array desses objetos
// (para casos como filtro que precisa de "Todos" + "Sem entregador").
export function Combobox({ options, value, onChange, placeholder = "Selecione", testId, allowClear = true, noneOption = null }) {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.id === value);
  const extras = noneOption ? (Array.isArray(noneOption) ? noneOption : [noneOption]) : [];
  const extraSelected = extras.find((x) => x.value === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open}
          className="w-full justify-between font-normal" data-testid={testId}>
          <span className="truncate text-left">
            {selected?.nome
              ? <>{selected.nome}{selected.sub && <span className="text-muted-foreground text-xs"> · {selected.sub}</span>}</>
              : (extraSelected
                  ? <span className="text-muted-foreground">{extraSelected.label}</span>
                  : <span className="text-muted-foreground">{placeholder}</span>)}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[300px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Digite para buscar..." data-testid={`${testId}-input`} />
          <CommandList>
            <CommandEmpty>Nenhum resultado.</CommandEmpty>
            <CommandGroup>
              {allowClear && (
                <CommandItem value="__clear__" onSelect={() => { onChange(""); setOpen(false); }}>
                  <span className="text-muted-foreground">— Limpar —</span>
                </CommandItem>
              )}
              {extras.map((x) => (
                <CommandItem key={x.value} value={x.label} onSelect={() => { onChange(x.value); setOpen(false); }}>
                  <Check className={cn("mr-2 h-4 w-4", value === x.value ? "opacity-100" : "opacity-0")} />
                  <span className="text-muted-foreground">{x.label}</span>
                </CommandItem>
              ))}
              {options.map((o) => (
                <CommandItem key={o.id} value={o.sub ? `${o.nome} ${o.sub}` : o.nome} onSelect={() => { onChange(o.id); setOpen(false); }}>
                  <Check className={cn("mr-2 h-4 w-4", value === o.id ? "opacity-100" : "opacity-0")} />
                  <span className="flex-1 truncate">{o.nome}</span>
                  {o.sub && <span className="ml-2 text-xs text-muted-foreground shrink-0" data-testid={`${testId}-sub-${o.id}`}>{o.sub}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
